// extracted by mini-css-extract-plugin
export default {"root":"index__root--uqbA7","close":"index__close--l5-ss","view":"index__view--nq5fs"};